import { atom } from 'jotai';

/**
 * Interface for choice group details in API response
 */
export interface ChoiceGroupDetail {
  choiceGroupId: string;
  choiceGroupName: string;
}

/**
 * Main interface for Meal data
 * Matches the actual API response structure from /core/meal/getAll
 */
export interface MealDataType {
  mealId: string;
  mealNameEnglish: string;
  mealNameArabic: string;
  storeId: string;
  storeName: string;
  storeType: string;
  itemId?: string;
  itemName?: string;
  choiceGroupDetails: ChoiceGroupDetail[];
  price: number;
  currency: string;
  status: 'blocked' | 'unblocked';
  addedBy: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Jotai atom for managing selected meal data
 * Used for edit operations - stores the meal being edited
 */
export const mealAtom = atom<MealDataType | null>(null);
